import { useMemo } from "react";
import { hardcodedDashboardOptions } from "../supplyChainHooks/hardcodedDashboardOptions";

export const useGetReleaseGenreText = (
  genre: number | null,
  secondaryGenre: number | null,
) => {
  const primaryGenreOption = useMemo(
    () =>
      hardcodedDashboardOptions.genres.find((option) => option.id === genre),
    [genre],
  );

  const primaryGenreText = useMemo(() => {
    if (!primaryGenreOption) return null;
    return primaryGenreOption.name;
  }, [primaryGenreOption]);

  const secondaryGenreText = useMemo(() => {
    if (!secondaryGenre || !primaryGenreOption) return null;
    return (
      primaryGenreOption.children.find(
        (secondary) => secondary.id === secondaryGenre,
      )?.name || null
    );
  }, [secondaryGenre, primaryGenreOption]);

  return useMemo(() => {
    if (!primaryGenreText) return "";
    if (secondaryGenreText) {
      return `${primaryGenreText}/${secondaryGenreText}`;
    }
    return primaryGenreText;
  }, [primaryGenreText, secondaryGenreText]);
};
